import { IconProps } from "@chakra-ui/react";
import { useMemo } from "react";

import { RanaLoadingProps } from "@nens/ranalib";

import { AnyFile } from "../types/any-file";
import { getFileIcon } from "../utils/get-file-display-type-and-icon";

type RestProps = IconProps & RanaLoadingProps;

interface FileOrFolderIconProps extends RestProps {
  fileOrDirectory: AnyFile;
  layerInFile?: string;
}

const PROPS: RestProps = {
  boxSize: 3,
  mr: 2,
  color: "brand.clear_creek",
  display: "inline-flex",
};

export function RanaFileIcon({ fileOrDirectory, layerInFile, ...rest }: FileOrFolderIconProps) {
  const Icon = useMemo(
    () => getFileIcon(fileOrDirectory, layerInFile),
    [fileOrDirectory, layerInFile]
  );

  return <Icon {...PROPS} {...rest} />;
}
